@if (loaded) {
    <cerrix-riskmatrix
        [matrix]="matrix"
        [cellBorder]="0"
        [highlightSelection]="false"
        [readonly]="disabled"
        (selectedChange)="cellClicked($event)"
    >
    </cerrix-riskmatrix>
}
